package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

/**
 * Translations for the Registrations List page
 */
enum class RegistrationsListI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    FORM_TITLE(mapOf(PageLocale.PT to "Consultar Registos")),

    START_DATE_COLUMN(mapOf(PageLocale.PT to "Data de Início")),
    REQUEST_DATE_COLUMN(mapOf(PageLocale.PT to "Data de Pedido")),
    NETP_STATUS_COLUMN(mapOf(PageLocale.PT to "Situação")),
    NETP_UPDATE_TIMESTAMP_COLUMN(mapOf(PageLocale.PT to "Data atualização")),
    COMPANY_NAME_COLUMN(mapOf(PageLocale.PT to "Denominação")),
    NETP_ACTIONS_COLUMN(mapOf(PageLocale.PT to "")),

    REGISTRATION_DETAIL_BUTTON(mapOf(PageLocale.PT to "consultar")),
    REGISTRATION_CANCEL_BUTTON(mapOf(PageLocale.PT to "cancelar")),
    ;
}
